exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hp-content-on-image[data-brand=infiniti] .sokal-btn[data-v-4483dc3d]{border:3px solid var(--primary-light,#fff);background-color:var(--primary-light,#fff);color:var(--primary-color,#020b24);-webkit-transition-property:all;transition-property:all}.hp-content-on-image[data-brand=infiniti] .sokal-btn[data-v-4483dc3d]:after{display:none}.hp-content-on-image[data-brand=infiniti] .sokal-btn[data-v-4483dc3d]:focus,.hp-content-on-image[data-brand=infiniti] .sokal-btn[data-v-4483dc3d]:hover{background-color:transparent;color:var(--primary-light,#fff)}", ""]);

// exports
